import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import 'url-search-params-polyfill';
import { SAlertComponent } from '../../shared/components/s-alert/s-alert.component';
import { AuthenticationService } from '../../services/authentication.service';
import { ResponseEnum } from '../../enums/ResponseEnum.enum';
import { MesaggeText } from '../../shared/texts/mesagge-text';
import { AsociadoModel } from '../../shared/models/datosAsociado';
import { IResponseService } from '../../interfaces/response-service';
import { FormService } from '../../services/form.service';
import { AddressesUrlParams } from '../../parameters/addresses-url-params';
import { IResponseLoginService } from '../../interfaces/response-login-service';
import { MainStore } from '../../store/main-store';
import { Utils } from '../../utils/utils';
import { MENU_ITEM } from '../menu';


@Component({
  selector: 'app-loginSilencioso',
  templateUrl: './loginSilencioso.component.html',
  styleUrls: ['./loginSilencioso.component.scss']
})
export class LoginSilensiosoComponent implements OnInit {
  
  objAsociado: AsociadoModel;
  public usuario: string;
  public password: string;
  public campanaEmpresa: string;
  public empresaList: any[] = [];

  constructor(private route: Router,
    public authService: AuthenticationService,
    public formServ: FormService) { 
      let urlTree = this.route.parseUrl(route.url);
      this.usuario = atob(urlTree.queryParams['login']);
      this.objAsociado = new AsociadoModel();
    }

  ngOnInit() {
    this.login();
  }

  public login() {
      var data = { 'texto': this.usuario };
      this.authService.sendLogin(data).
      then((response) => {
        if (response.status == 'FAILURE') {
          console.log(response)
          SAlertComponent.AlertError(response.message);
          return;
        } else if (response.status == 'OK') {

          this.CheckResponse(response);
        }
      }, (fail) => {
        console.log(fail)
        SAlertComponent.AlertError('Error al invocar login silensioso, verifique los par&aacute;metros enviados');
      })
  }

  CheckResponse(response: IResponseService): any {
    
    if (response.status == ResponseEnum.OK) {
      let infoAsociado = response.data;
      this.formServ.getCuentaMatricula(response.data.numDocumento).
      then((response) => {
        let matricula = response.data;

        if(matricula != undefined && matricula != null) {
          SAlertComponent.AlertInfo('Asociado(a): Su cuenta ya ha sido inscrita, en caso de requerir modificar sus datos o '
          + 'para mayor informaci\u00F3n por favor comunicarse con la línea 300 910 9898 opci\u00F3n 1-2-5.');
          return;
        }
        
        this.LoadData(infoAsociado);
        this.LoadMenu(infoAsociado);
        setTimeout(() => {
          return this.route.navigateByUrl(AddressesUrlParams.PathInicio());
        }, 1000);
        
      }, (fail) => {
        SAlertComponent.AlertError('Error en el servicio ' + fail);
      })


      
    } else if (response.status == ResponseEnum.FAILURE) {
      SAlertComponent.AlertError(
        MesaggeText.TITLE_ALERT,
        response.messageError
      );
      return;
    }
  }

  LoadMenu(data: IResponseLoginService) {
    let actions: Array<string> = [];
    MainStore.db.ClearMenu();
    let newList = this.FilterItemMenu(
      Utils.CopyJson(MENU_ITEM),
      actions
    );
    newList.forEach(x => MainStore.db.AddMenu(x));
  }

  LoadData(data: any): any {
    this.objAsociado.nombre1 = data.nombre1;
    this.objAsociado.nombre2 = data.nombre2;
    this.objAsociado.primerApellido = data.primerApellido;
    this.objAsociado.segundoApellido = data.segundoApellido;
    this.objAsociado.numeroDocumento = data.numDocumento;
    this.objAsociado.estado = data.estado;
    this.objAsociado.email = data.email;
    MainStore.db.SetUser(this.objAsociado);
  }

  FilterItemMenu(objs: object, actions: string[]): any[] {
    let newList = [];
    for (const key in objs) {
      let pos: number = actions.findIndex(x => x == key);

      if (pos != -1) {
        let itemmenu = objs[key];
        let children = itemmenu.children;
        itemmenu.children = [];
        if (children) {
          actions.splice(pos, 1);
          itemmenu.children = this.FilterItemMenu(children, actions);
        }
        newList.push(itemmenu);
      }
    }
    return newList;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/loginSilencioso/loginSilencioso.component.ts